import { queryClient } from "@/queryClient";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/resources/")({
  staticData: {
    title: "common.resources",
  },
  loader: async ({ params }) => {
    if (!params.id) {
      return undefined;
    }

    const { queries } = await import("@/modules/sources/fleets/services/queries");
    return queryClient.ensureQueryData(queries.getFleetResources(Number(params.id)));
  },
});
